import { useContext } from 'react';
import useGlobalStaticApiResponse from '@/lib/api/useGlobalStaticApiResponse';
import useImageAsDataUrl from '@/lib/utils/useImageAsDataUrl';
import StyledThumbnailImage from './StyledThumbnailImage';
import ThumbnailLoadingPlaceholder from '../ThumbnailLoadingPlaceholder';
import ShouldGetImagesFromPublicApiContext from '@/components/FileAttachments/ShouldGetImagesFromPublicApiContext';
import shouldShowInappropriateContentIndicators from '@/lib/files/shouldShowInappropriateContentIndicators';
import ThumbnailWrapper from './ThumbnailWrapper';
import ThumbnailInappropriateContentOverlay from './ThumbnailInappropriateContentOverlay';
import PortfolioItemCardThumbnailContext from '../PortfolioItemCardThumbnailContext';

const ThumbnailImage = () => {
  const { portfolioItemSummary, portfolioItemApiEndpoint } = useContext(
    PortfolioItemCardThumbnailContext,
  );

  const shouldGetImagesFromPublicApi = useContext(
    ShouldGetImagesFromPublicApiContext,
  );

  const [loading, imageBlob] = useGlobalStaticApiResponse<Blob>(
    `${portfolioItemApiEndpoint}/thumbnail/${portfolioItemSummary.thumbnail.id}/tiny${shouldGetImagesFromPublicApi ? '/public' : ''}`,
  );
  const imageAsDataUrl = useImageAsDataUrl(
    portfolioItemSummary.thumbnail.file.thumbnailStorageFilename!,
    imageBlob,
  );

  if (loading || imageAsDataUrl === null) {
    return <ThumbnailLoadingPlaceholder />;
  }

  const showInappropriateContentIndicators =
    shouldShowInappropriateContentIndicators(portfolioItemSummary.thumbnail);

  return (
    <ThumbnailWrapper>
      <StyledThumbnailImage src={imageAsDataUrl} />
      {showInappropriateContentIndicators && (
        <ThumbnailInappropriateContentOverlay />
      )}
    </ThumbnailWrapper>
  );
};

export default ThumbnailImage;
